import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { clientFadeOutAnimation } from '@core/animations/client-fade.animation';
import { CONFIG_MODAL_INPUTS_TOKEN, ModalOverlayRef } from '@core/classes/modal-overlay.ref';

@Component({
  selector: 'mfp-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [clientFadeOutAnimation]
})
export class ToastComponent implements OnInit {
  @Input() message = '';
  @Input() duration = 0;

  animationStatus = 'in';

  constructor(public dialogRef: ModalOverlayRef, @Optional() @Inject(CONFIG_MODAL_INPUTS_TOKEN) config: any) {
    if (config) {
      this.message = config.message;
      this.duration = config.duration;
    }
  }

  ngOnInit(): void {
    if (this.duration > 0) {
      setTimeout(() => {
        this.animationStatus = 'out';
        setTimeout(() => {
          this.close();
        }, 400);
      }, this.duration);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
